export var AssetType;
(function (AssetType) {
    AssetType["URL"] = "URL";
    AssetType["LIVE"] = "LIVE";
    AssetType["VOD"] = "VOD";
    AssetType["VOD_TRAILER"] = "VOD_TRAILER";
    AssetType["REPLAY"] = "REPLAY";
    AssetType["RECORDING"] = "RECORDING";
    AssetType["REGISTERED_TIMESHIFT"] = "REGISTERED_TIMESHIFT";
})(AssetType || (AssetType = {}));
